var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreloaderGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 199,
    viewBox: "0 0 404 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M276 148.5H128C127.172 148.5 126.5 149.172 126.5 150V162C126.5 162.828 127.172 163.5 128 163.5H276C276.828 163.5 277.5 162.828 277.5 162V150C277.5 149.172 276.828 148.5 276 148.5Z",
    fill: "#D9D9D9",
    stroke: "#DEE2E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M225 87.5H179C178.172 87.5 177.5 88.1716 177.5 89V135C177.5 135.828 178.172 136.5 179 136.5H225C225.828 136.5 226.5 135.828 226.5 135V89C226.5 88.1716 225.828 87.5 225 87.5Z",
    fill: "#D9D9D9",
    stroke: "#DEE2E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M310 179.5H94C93.1716 179.5 92.5 180.172 92.5 181V197C92.5 197.828 93.1716 198.5 94 198.5H310C310.828 198.5 311.5 197.828 311.5 197V181C311.5 180.172 310.828 179.5 310 179.5Z",
    fill: "#D9D9D9",
    stroke: "#DEE2E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63 184.5H2C1.17157 184.5 0.5 185.172 0.5 186V197C0.5 197.828 1.17157 198.5 2 198.5H63C63.8284 198.5 64.5 197.828 64.5 197V186C64.5 185.172 63.8284 184.5 63 184.5Z",
    fill: "#D9D9D9",
    stroke: "#DEE2E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M402 184.5H339C338.172 184.5 337.5 185.172 337.5 186V197C337.5 197.828 338.172 198.5 339 198.5H402C402.828 198.5 403.5 197.828 403.5 197V186C403.5 185.172 402.828 184.5 402 184.5Z",
    fill: "#D9D9D9",
    stroke: "#DEE2E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 18,
    width: 353,
    height: 157
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M378.885 18.2166H26.099V174.575H378.885V18.2166Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 18,
    width: 353,
    height: 157
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M202.495 18.2164C289.791 18.2164 364.516 81.9422 378.86 167.462C379.046 168.569 378.277 169.616 377.167 169.782L345.366 174.552C344.283 174.715 343.281 173.977 343.095 172.897C331.426 104.95 271.949 54.3844 202.495 54.3844C133.041 54.3844 73.5636 104.95 61.8941 172.897C61.7088 173.977 60.7064 174.715 59.6235 174.552L27.8219 169.782C26.712 169.616 25.9435 168.569 26.1291 167.462C40.4729 81.9422 115.198 18.2164 202.495 18.2164Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.495 18.2164C289.791 18.2164 364.516 81.9422 378.86 167.462C379.046 168.569 378.277 169.616 377.167 169.782L345.366 174.552C344.283 174.715 343.281 173.977 343.095 172.897C331.426 104.95 271.949 54.3844 202.495 54.3844C133.041 54.3844 73.5636 104.95 61.8941 172.897C61.7088 173.977 60.7064 174.715 59.6235 174.552L27.8219 169.782C26.712 169.616 25.9435 168.569 26.1291 167.462C40.4729 81.9422 115.198 18.2164 202.495 18.2164Z",
    fill: "#DEE2E5"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0063 118.976L29.5047 121.668C30.5066 122.083 31.6491 121.624 32.0976 120.637C37.2006 109.402 43.3864 98.7602 50.5236 88.8451C51.1585 87.9631 50.986 86.7413 50.1239 86.0796L44.546 81.7981C43.6481 81.1089 42.3507 81.2912 41.6883 82.2091C34.0248 92.8285 27.3935 104.237 21.9367 116.289C21.4688 117.322 21.9585 118.541 23.0063 118.976Z",
    fill: "#DEE2E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M358.895 81.7981L353.317 86.0796C352.455 86.7413 352.282 87.9631 352.917 88.8452C360.054 98.7601 366.24 109.401 371.343 120.636C371.791 121.624 372.934 122.083 373.936 121.668L380.434 118.975C381.482 118.541 381.971 117.322 381.504 116.288C376.047 104.237 369.416 92.8284 361.752 82.2091C361.09 81.2912 359.792 81.1089 358.895 81.7981Z",
    fill: "#DEE2E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M269.963 22.051L272.655 15.549C273.088 14.5031 272.576 13.2973 271.518 12.8955C259.361 8.28028 246.635 4.83225 233.476 2.69271C232.358 2.51095 231.308 3.29941 231.161 4.42239L230.243 11.3958C230.101 12.4726 230.843 13.4582 231.915 13.6338C244.184 15.6439 256.051 18.8624 267.396 23.1539C268.412 23.5384 269.547 23.055 269.963 22.051Z",
    fill: "#DEE2E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M312.968 45.7464L317.248 40.1672C317.937 39.269 317.754 37.9717 316.836 37.3096C306.219 29.6528 294.813 23.0274 282.765 17.5758C281.732 17.1082 280.513 17.5981 280.079 18.646L277.388 25.145C276.973 26.1471 277.432 27.2895 278.42 27.7378C289.651 32.8359 300.29 39.016 310.203 46.147C311.085 46.7816 312.307 46.6087 312.968 45.7464Z",
    fill: "#DEE2E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.19 11.3958L172.272 4.42239C172.124 3.2994 171.075 2.51094 169.957 2.69272C156.798 4.8323 144.072 8.28027 131.916 12.8955C130.857 13.2973 130.345 14.5031 130.779 15.549L133.471 22.051C133.887 23.055 135.021 23.5384 136.038 23.1539C147.382 18.8624 159.249 15.6439 171.518 13.6337C172.589 13.4581 173.332 12.4726 173.19 11.3958Z",
    fill: "#DEE2E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M323.618 45.0675L319.338 50.646C318.678 51.5069 318.826 52.7297 319.665 53.4181C329.149 61.2029 337.853 69.9037 345.641 79.3858C346.329 80.2242 347.552 80.372 348.413 79.7113L353.99 75.4305C354.889 74.7402 355.047 73.4367 354.329 72.5598C345.993 62.3868 336.664 53.0604 326.488 44.728C325.611 44.0097 324.308 44.1679 323.618 45.0675Z",
    fill: "#DEE2E5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M383.527 126.389L377.026 129.083C376.022 129.499 375.538 130.634 375.923 131.65C380.221 143.002 383.444 154.877 385.456 167.156C385.632 168.227 386.618 168.969 387.694 168.828L394.668 167.909C395.791 167.761 396.579 166.712 396.397 165.594C394.255 152.425 390.802 139.69 386.181 127.525C385.779 126.467 384.573 125.956 383.527 126.389Z",
    fill: "#DEE2E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M181.156 10.3631C181.297 11.4392 182.266 12.1998 183.346 12.0932C189.39 11.4966 195.517 11.1827 201.715 11.1827C207.914 11.1827 214.04 11.4966 220.084 12.0932C221.164 12.1998 222.133 11.4392 222.274 10.363L223.192 3.38877C223.34 2.26516 222.532 1.23254 221.404 1.11987C214.927 0.472652 208.361 0.131348 201.715 0.131348C195.07 0.131348 188.503 0.472703 182.025 1.11993C180.898 1.2326 180.09 2.26521 180.238 3.38883L181.156 10.3631Z",
    fill: "#DEE2E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2328 46.1473C103.146 39.0162 113.784 32.836 125.016 27.7378C126.004 27.2895 126.463 26.1471 126.048 25.145L123.357 18.646C122.923 17.5981 121.704 17.1082 120.67 17.5758C108.623 23.0275 97.2169 29.653 86.5996 37.3099C85.6815 37.972 85.4988 39.2693 86.1877 40.1675L90.4674 45.7467C91.1288 46.609 92.3506 46.7819 93.2328 46.1473Z",
    fill: "#DEE2E5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3976 129.085L19.8962 126.391C18.8503 125.957 17.6444 126.469 17.2424 127.527C12.6209 139.691 9.16842 152.426 7.02612 165.595C6.84425 166.713 7.63262 167.763 8.75561 167.911L15.729 168.829C16.8057 168.971 17.7913 168.229 17.967 167.157C19.9797 154.879 23.2025 143.003 27.4999 131.652C27.8847 130.635 27.4015 129.501 26.3976 129.085Z",
    fill: "#DEE2E5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1027 50.646L79.8236 45.0675C79.1336 44.1679 77.8302 44.0097 76.953 44.728C66.7775 53.0603 57.4483 62.3868 49.1128 72.5597C48.3942 73.4366 48.552 74.74 49.4514 75.4304L55.0284 79.7112C55.8891 80.3718 57.112 80.2241 57.8006 79.3856C65.5884 69.9036 74.2917 61.203 83.7763 53.4181C84.615 52.7297 84.7631 51.5069 84.1027 50.646Z",
    fill: "#DEE2E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 404,
    height: 199,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreloaderGraph);
export default __webpack_public_path__ + "static/media/PreloaderGraph.643f3a63d9e6ab04031d048976e7c792.svg";
export { ForwardRef as ReactComponent };